import React from 'react';

export default function StaffAugmentationSection({ service }) {
  // console.log(service)
  return (
    <div className=" bg-white">
      {/* Header Section */}
      <div data-aos="fade-up" data-aos-duration="1000" className="max-w-[1400px] mx-auto px-6 xl:py-20 md:py-14 py-7">
        <h1 data-aos="fade-up" data-aos-duration="1000" className="text-3xl sm:text-4xl lg:text-5xl font-semibold font-SpaceGrotesk text-primaryColor mb-8">
          {service?.section1?.title}
        </h1>

        {/* Description Paragraphs */}
        <div className="space-y-6 text-gray-700 text-sm sm:text-base leading-relaxed">
          {
            service?.section1?.content?.map((text, index) => (
              <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} key={index} className='text-justify md:text-left'>{text}</p>
            ))
          }
        </div>
      </div>

      {/* Image Grid Section */}
      <div className="max-w-[1400px] mx-auto px-6 xl:pb-20 md:pb-14 pb-7">
        <div data-aos="fade-up" data-aos-duration="1000" className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
          {
            service?.gallery?.map((img, index) => (
              <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} key={index} className="relative aspect-[4/3] bg-gray-200 rounded-lg overflow-hidden">
                <img
                  src={img}
                  alt="Team meeting in conference room"
                  className="w-full h-full object-cover"
                />
              </div>
            ))
          }
        </div>
      </div>

      {/* Bottom Section */}
      <div data-aos="fade-up" data-aos-duration="1000" className="max-w-[1400px] mx-auto px-6 xl:pb-20 md:pb-14 pb-7">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold font-SpaceGrotesk text-primaryColor mb-6">
          {service?.section2?.title}
        </h2>

        <div className="space-y-6 text-gray-700 text-sm sm:text-base leading-relaxed">
          {
            service?.section2?.content?.map((text, index) => (
              <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} key={index} className='text-justify md:text-left'>{text}</p>
            ))
          }
        </div>
      </div>
    </div>
  );
}